import { coverageStatsSchema } from "@redotech/redo-dispute-db-schema/dispute-overview-analytics";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getDisputeCoverageStats = {
  name: "getDisputeCoverageStats" as const,
  input: z.object({
    startDate: zExt.plainDate().optional(),
    endDate: zExt.plainDate().optional(),
  }),
  output: coverageStatsSchema,
};
